import { takeLatest, put, all, call } from "redux-saga/effects";
import {
  PLACE_NEW_ORDER_REQUEST,
  PLACE_NEW_ORDER_SUCCESS,
  GET_ALL_PLACED_ORDERS_REQUEST,
  GET_ALL_PLACED_ORDERS_SUCCESS,
  GET_MORE_PLACED_ORDERS_REQUEST,
  GET_MORE_PLACED_ORDERS_SUCCESS,
  FETCH_ORDER_CANCELLATION_REASONS_REQUEST,
} from "../reducers/actionTypes";

import {
  placeNewOrder,
  getAllOrders,
  orderCancellationReasons,
} from "@services/api";
import { store } from "@store";
import { actions as orderActions } from "@reducers/orderReducer";

function* placeNewOrderSaga(params) {
  try {
    const { payload = {} } = params;
    const { data } = yield call(placeNewOrder, payload);
    yield put({
      type: PLACE_NEW_ORDER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
  }
}

function* getMorePlaceOrders(action) {
  try {
    const {
      offset = 0,
      limit = 10,
      query = "",
      date,
    } = action && action.payload;
    const { data } = yield call(getAllOrders, { offset, limit, query, date });

    yield put({
      type: GET_MORE_PLACED_ORDERS_SUCCESS,
      orders: data,
    });
  } catch (error) {
    console.log(error);
  }
}
function* getAllPlaceOrders(action) {
  try {
    const {
      offset = 0,
      limit = 10,
      query = "",
      date,
      userId,
    } = action && action.payload;
    const { data } = yield call(getAllOrders, {
      offset,
      limit,
      query,
      date,
      userId,
    });
    yield put({
      type: GET_ALL_PLACED_ORDERS_SUCCESS,
      orders: data,
      count: data.length,
    });
  } catch (error) {
    console.log(error);
  }
}

function* getCancellationOrders(action) {
  try {
    const { data } = yield call(orderCancellationReasons);

    const reasons = Object.keys(data).map(function (key) {
      return { key: key, text: data[key] };
    });

    yield put(orderActions.fetchCancellationReasonsSuccess(reasons));
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield all([
    takeLatest(PLACE_NEW_ORDER_REQUEST, placeNewOrderSaga),
    takeLatest(GET_ALL_PLACED_ORDERS_REQUEST, getAllPlaceOrders),
    takeLatest(GET_MORE_PLACED_ORDERS_REQUEST, getMorePlaceOrders),
    takeLatest(FETCH_ORDER_CANCELLATION_REASONS_REQUEST, getCancellationOrders),
  ]);
}
